import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, computed, Inject } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { UserSectionAccessComponent } from '~/core/components'
import { IRouterFacade, ROUTER_FACADE } from '~/core/features'
import { EGuardSection } from '~/core/models'

import { HistoricalDataContainerComponent } from './containers'

@Component({
  selector: 'app-historical-data',
  templateUrl: './historical-data.component.html',
  styleUrl: './historical-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, UserSectionAccessComponent, HistoricalDataContainerComponent],
})
export class HistoricalDataComponent {
  readonly guardSection = computed(() =>
    this.isCompanyPage() ? EGuardSection.COMPANY_INFO_HISTORY : EGuardSection.FORECAST_INFO_HISTORY
  )

  private readonly isCompanyPage = toSignal(this.routerFacade.isCompanyPage$)

  constructor(@Inject(ROUTER_FACADE) private routerFacade: IRouterFacade) {}
}
